import {RoutesParts} from '../../constants/routes-parts';
import {RoutesPaths} from '../../routes/routes-paths/routes-paths';

export const RegistrationRoutesPaths = {
  PROSPECT_DATA: RoutesPaths.REGISTRATION + RoutesParts.USER_DATA,
  OTP: RoutesPaths.REGISTRATION + RoutesParts.OTP,
  SET_PASSWORD: RoutesPaths.REGISTRATION + RoutesParts.SET_PASSWORD
};
